<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch, computed } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import SelectBox from "../../compositions/SelectBox.vue";
import TextBox from "../../compositions/TextBox.vue";

import config from "../../config.js";
import { errorAlert } from "../../plugins/alert";
import { getFieldValue } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyRelationSetting:{
      type:Object,
      required:true,
    },
    cancel:{
      type:Function,
      required:true,
    },
    updateComplete:{
      type:Function,
      required:true,
    },
})
const { pharmacyRelationSetting } = toRefs(props);
const isLoadingDialog = ref(false);
const pharmacyRelationSettingData = reactive([]);
const onSelectChange = (value,label,option) => {
  if (option.type == 'amount_float_type') {
    pharmacyRelationSettingData[0].amount_float_type = value;
  } else if (option.type == 'tax_total_type') {
    pharmacyRelationSettingData[0].tax_total_type = value;
  }
}
const updatePharmacyRelationSetting = async () => {
  isLoadingDialog.value = true;
  let params = new FormData();
  params.append('id', pharmacyRelationSettingData[0].id);
  params.append('amount_float_type', pharmacyRelationSettingData[0].amount_float_type);
  params.append('tax_total_type', pharmacyRelationSettingData[0].tax_total_type);
  params.append('establish_permit_number', establishPermitNumber.value);
  params.append('establish_permit_expire_date', establishPermitExpireDate.value);
  params.append('establish_permit_file', establishPermitFile.value);
  try {
    const response = await axios(props.apis.pharmacy_relation_setting_update,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.updateComplete !== 'undefined') {
        props.updateComplete(response.data.data);
      }
    }
  } finally {
    isLoadingDialog.value = false;
  }
}
/////// 許可証登録 //////
const establishPermitFile = ref(new Object());
const establishPermitNumber = ref('');
const establishPermitExpireDate = ref('');
const onChangeEstablishPermitNumber = (value) => {
  establishPermitNumber.value = value;
}
const onChangeEstablishPermitExpireDate = (value) => {
  establishPermitExpireDate.value = value;
}
const onEstablishPermitFileUpload = (e) => {
  establishPermitFile.value = e.target.files[0];
}
////////////
watch(pharmacyRelationSetting,(newValue, oldValue) => {
  pharmacyRelationSettingData.splice(0);
  pharmacyRelationSettingData.push(newValue);
  establishPermitFile.value = null;
  establishPermitNumber.value = newValue.relation_pharmacy.establish_permit_number;
  establishPermitExpireDate.value = (newValue.relation_pharmacy.establish_permit_expire_date ? newValue.relation_pharmacy.establish_permit_expire_date.replace(/\//g,'-') : '');
},{deep:true})
onMounted(() => {
  pharmacyRelationSettingData.splice(0);
  if (typeof props.pharmacyRelationSetting.id !== 'undefined') {
    pharmacyRelationSettingData.push(props.pharmacyRelationSetting);
  }
});
const isOuterSystemPharmacy = computed(() => {
  let result = false;
  if (pharmacyRelationSettingData.length > 0) {
    if (pharmacyRelationSettingData[0].relation_pharmacy.is_active == false) {
      result = true;
    }
  }
  return result;
})
</script>

<style scoped>
</style>
<template>
<div class="mb-6">
  <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
    <div class="text-lg font-bold" v-for="pharmacyRelationSettingRecord in pharmacyRelationSettingData" :key="pharmacyRelationSettingRecord.id">
      <div>{{ pharmacyRelationSettingRecord.medicine_group_name + ' ' + pharmacyRelationSettingRecord.relation_pharmacy.pharmacy_name }}</div>
      <div v-if="isOuterSystemPharmacy" class="m-1">
        <div class="flex flex-row items-center mb-1">
          <a v-show="pharmacyRelationSettingRecord.relation_pharmacy.establish_permit_url.length > 0" :href="pharmacyRelationSettingRecord.relation_pharmacy.establish_permit_url" target="blank" class="block cursor-pointer text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-4 py-1 w-full sm:w-auto text-center ml-2">開設許可証</a>
        </div>
        <div>
          <table class="w-full">
            <tr class="border-b border-white">
              <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証</th>
              <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="file" @change="onEstablishPermitFileUpload">
                <p>前回アップロード日時：{{ pharmacyRelationSettingRecord.relation_pharmacy.establish_permit_upload_date }}</p>
              </td>
            </tr>
            <tr class="border-b border-white">
              <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証番号</th>
              <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                <text-box
                  type="text"
                  :value="establishPermitNumber"
                  :on-change="onChangeEstablishPermitNumber"
                ></text-box>
              </td>
            </tr>
            <tr class="border-b border-white">
              <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証有効期限</th>
              <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                <text-box
                  type="date"
                  :value="establishPermitExpireDate"
                  :on-change="onChangeEstablishPermitExpireDate"
                ></text-box>
              </td>
            </tr>
          </table>
        </div>
        <div>TEL:{{ pharmacyRelationSettingRecord.relation_pharmacy.pharmacy_telephone }} FAX:{{ pharmacyRelationSettingRecord.relation_pharmacy.pharmacy_fax }}</div>
        <div>営業時間：<span class="crlf-area">{{ pharmacyRelationSettingRecord.relation_pharmacy.pharmacy_business_hour }}</span></div>
      </div>
    </div>
  </div>
  <div class="md:border p-2">
    <table class="w-full">
      <tr class="border-b border-white" v-for="pharmacyRelationSettingRecord in pharmacyRelationSettingData" :key="pharmacyRelationSettingRecord.id">
        <td class="block py-3 text-sm md:table-cell md:w-1/3 md:px-3 md:py-2">
          <select-box
            :value-options="{type:'tax_total_type'}"
            :options="config.TAX_TOTAL_TYPES"
            :on-change="onSelectChange"
            :value="pharmacyRelationSettingRecord.tax_total_type"
          ></select-box>
        </td>
        <td class="block py-3 text-sm md:table-cell md:w-1/3 md:px-3 md:py-2">
          <select-box
            :value-options="{type:'amount_float_type'}"
            :options="config.AMOUNT_FLOAT_TYPES"
            :on-change="onSelectChange"
            :value="pharmacyRelationSettingRecord.amount_float_type"
          ></select-box>
        </td>
      </tr>
    </table>
  </div>
  <div class="flex">
    <div class="flex-row mr-2">
      <button type="button" @click="updatePharmacyRelationSetting" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
    </div>
    <div class="flex-row">
      <button type="button" @click="cancel" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
</template>

